import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Select, { createFilter } from 'react-select'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'

export const SelectField = props => {
    const { field, form, options, productId } = props
    const { shopifyProducts } = useSelector(GET_STORE.SUPPLIER)
    const hideDropdown = options.length > 1000

    useEffect(() => {
        const option = options.find(({ value }) => form.values.shopifyVariantId === value)
        changeHandler(option)

        //! Adding any other dependencies causes an infinite loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shopifyProducts])

    const changeHandler = option => {
        form.setFieldValue(field.name, option)
        form.setFieldValue('shopifyProductId', option?.shopifyProductId)
        form.setFieldValue('shopifyVariantId', option?.value)
        form.setFieldValue('sku', option?.sku)
        form.setTouched(field.name, true)
        form.setFieldValue('removeShopifyProducts', !option) // Could be object or null
    }
    return (
        <div className="SelectField-container">
            <Select
                {...props}
                className="select"
                components={{
                    ...(hideDropdown && { DropdownIndicator: () => null }),
                    ...(hideDropdown && { IndicatorSeparator: () => null }),
                }}
                filterOption={createFilter({ ignoreAccents: false })}
                hideSelectedOptions={true}
                id={`shopifyProduct-${productId}`}
                isSearchable={true}
                isClearable={true}
                menuPortalTarget={document.body}
                options={options}
                onChange={changeHandler}
                openMenuOnClick={!hideDropdown}
                openMenuOnFocus={!hideDropdown}
                placeholder={<div className="option">Start typing to search...</div>}
                styles={{
                    control: (provided, data) => ({
                        ...provided,
                        alignItems: 'center',
                        display: 'flex',
                        paddingLeft: '5px',
                        ':before': {
                            backgroundImage: `url(${data.getValue()[0]?.imageSrc || 'https://via.placeholder.com/150/CCC/333?text=?'})`,
                            backgroundSize: 'cover',
                            borderRadius: 4,
                            content: '""',
                            display: 'inline-block',
                            flexShrink: 0,
                            height: 28,
                            width: 28,
                        },
                    }),
                    option: (provided, data) =>
                        hideDropdown
                            ? { ...provided }
                            : {
                                  ...provided,
                                  alignItems: 'center',
                                  display: 'flex',
                                  ':before': {
                                      backgroundImage: `url(${
                                          data.options.find(option => option.value === data.value)?.imageSrc ||
                                          'https://via.placeholder.com/150/CCC/333?text=?'
                                      })`,
                                      backgroundSize: 'cover',
                                      borderRadius: 4,
                                      content: '""',
                                      display: 'inline-block',
                                      flexShrink: 0,
                                      height: 28,
                                      marginRight: '8px',
                                      width: 28,
                                  },
                              },
                }}
                value={field.value}
            />
            {/* <p>{form.}</p> */}
        </div>
    )
}
